import Alert from '@mui/material/Alert/Alert';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';

export const OutsideBRLMarketHoursAlert: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <Alert severity="warning">
      <Typography variant="body1" color="custom.LightGray">
        {tr('BRL_MARKET_HOURS_ALERT')}
      </Typography>
    </Alert>
  );
};
